import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/error/404.jsx");
